export const DEFAULT_ONE_DRIVE_SPECIAL_ATTACHMENT_FOLDER_PATH = 'special/attachments';
